(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/betslip/betslip-payoptions-container.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/betslip/betslip-payoptions-container.js');
"use strict";


const _ReactRouterDOM = ReactRouterDOM,
  withRouter = _ReactRouterDOM.withRouter;
const mapStateToProps = (state, _ref) => {
  let match = _ref.match;
  const drawNumber = Number(match.params.drawNumber);
  const coupon = svs.challenge.helpers.getCouponByDrawNumber(state, drawNumber);
  return {
    amounts: coupon.amounts,
    chosenBetPrice: coupon.chosenBetPrice,
    draw: svs.challenge.helpers.getDrawByDrawNumber(drawNumber, state),
    drawEvents: coupon.drawEvents,
    rowPrice: coupon.chosenBetPrice
  };
};
const mapDispatchToProps = {
  selectBetAmount: svs.challenge.actions.selectBetAmount
};
svs.challenge.BetslipPayOptionsContainer = withRouter(ReactRedux.connect(mapStateToProps, mapDispatchToProps)(svs.challenge.BetslipPayOptions));

 })(window);